import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassCheckoutTotal = (props: Props) => {
  const { total } = props;
  const { formatNumber } = useIntl();

  return (
    <View style={styles.container}>
      <BodyText sizeMatch={['18']} bold>
        <FormattedMessage {...messages.total} />
      </BodyText>

      <BodyText sizeMatch={['18']} bold>
        {formatNumber(total, { style: 'currency', currency: 'USD' })}
      </BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing['4'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  total: {
    defaultMessage: 'Total',
    description: 'Sweetpass | Checkout | Total | Title',
  },
});

// ─── Props ───────────────────────────────────────────────────────────────────

type Props = {
  total: number;
};
